import { ColumnDef, Row, Table } from '@tanstack/react-table';

import { Checkbox } from '@/components/ui/checkbox';

function SelectHeader<TData>({ table }: { table: Table<TData> }) {
  return (
    <Checkbox
      checked={
        table.getIsAllPageRowsSelected()
          ? true
          : table.getIsSomePageRowsSelected()
            ? 'indeterminate'
            : false
      }
      onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
      aria-label="Select all"
    />
  );
}

function SelectCell<TData>({ row }: { row: Row<TData> }) {
  return (
    <Checkbox
      checked={row.getIsSelected()}
      onCheckedChange={(value) => row.toggleSelected(!!value)}
      aria-label="Select row"
    />
  );
}

export function createSelectColumn<TData>(): ColumnDef<TData> {
  return {
    id: 'select',
    enableHiding: false,
    enableSorting: false,
    size: 40,
    header: ({ table }) => <SelectHeader table={table} />,
    cell: ({ row }) => <SelectCell row={row} />,
  };
}
